export const sharedProtocolsList = {
  viewProtocol: "View protocol",
  viewProtocolAriaLabel: "View {{protocolName}} protocol",
  viewProtocolNameOnlyAriaLabel: "View {{protocolName}}",
  thumbnailOverflow: "+{{count}}",
  thumbnailProductLabel: "{{protocolName}} product {{index}}",
  thumbnailResourceLabel: "{{protocolName}} resource {{index}}",
  thumbnailOverflowLabel: "{{count}} more items in {{protocolName}}",
  heading: "Public {{protocolNoun}}",
  subtitleEmpty:
    "{{- storeName}}'s general recommendations, available to anyone who visits this store.",
  subtitle: "{{- storeName}}'s general recommendation, available to anyone who visits this store.",
  subtitle_plural:
    "{{count}} of {{- storeName}}'s general recommendations, available to anyone who visits this store.",
  emptyDescription: "No {{protocolNoun}} are available yet. Check back soon.",
  loadingMoreProtocols: "Loading more protocols...",
  errorLoadingMoreProtocols: "Something went wrong loading more protocols. Please try again.",
};
